// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"532d50bc","92":"905392cc","160":"05461bdb","212":"9cccbcfe","384":"66371a79","521":"79cf83c4","787":"9fa620c5","998":"5d5912da"}[chunkId] + ".chunk.js";
};